import React from 'react';
import cn from '@/utils/cn';

interface JsonBlockProps {
  className?: string;
  value: unknown;
}

const JsonBlock = ({ className, value }: JsonBlockProps) => (
  <pre
    className={cn(
      'tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-200 tw-text-tci-black tw-font-mono',
      'tw-p-2 tw-rounded tw-overflow-x-auto tw-text-[11px] tw-leading-4 tw-m-0',
      className,
    )}
  >
    {JSON.stringify(value, null, 2)}
  </pre>
);

export default JsonBlock;
